export enum PettyWorkStatus {
  NEW = "NEW",
  IN_PROGRESS = "IN_PROGRESS",
  ON_HOLD = "ON_HOLD",
  /** IN_PROGRESS → here via submit-completion; awaiting supervisor review. */
  PENDING_COMPLETION_APPROVAL = "PENDING_COMPLETION_APPROVAL",
  /** Approved for billing; accounts still needs to submit-billing to generate the invoice. */
  READY_FOR_BILLING = "READY_FOR_BILLING",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}

export const pettyWorkStatusMap = {
  [PettyWorkStatus.NEW]: {
    label: "New",
    color: "primary",
  },
  [PettyWorkStatus.IN_PROGRESS]: {
    label: "In Progress",
    color: "warning",
  },
  [PettyWorkStatus.ON_HOLD]: {
    label: "On Hold",
    color: "secondary",
  },
  [PettyWorkStatus.PENDING_COMPLETION_APPROVAL]: {
    label: "Pending Approval",
    color: "info",
  },
  [PettyWorkStatus.READY_FOR_BILLING]: {
    label: "Ready for Billing",
    color: "primary",
  },
  [PettyWorkStatus.COMPLETED]: {
    label: "Completed",
    color: "success",
  },
  [PettyWorkStatus.CANCELLED]: {
    label: "Cancelled",
    color: "danger",
  },
};
